// Care team illustrations (frontend/public/images/care-team). Each is drawn
// as SVG with a PNG fallback; see Plate in ui.js.
const art = (name) => ({
  svg: `/images/care-team/${name}.svg`,
  png: `/images/care-team/${name}.png`,
});

export const MEADOW_PATH = art("meadow-path"); // provider sign-in / sign-up
export const GARDEN_BENCH = art("garden-bench"); // provider: no patients yet
export const WILDFLOWER_PATH = art("wildflower-path"); // player: no care team
